// extracted by mini-css-extract-plugin
export default {"root":"Search_root__eiX89","clearIcon":"Search_clearIcon__eIw10","input":"Search_input__klILD","icon":"Search_icon__XMmYc"};